import React from 'react';
import { withRouter } from 'react-router-dom';
import * as API from 'api';

import { withStyles } from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';
import MuiButton from '@material-ui/core/Button';
import MuiGrid from '@material-ui/core/Grid';
import MuiToolbar from '@material-ui/core/Toolbar';
import MuiTypography from '@material-ui/core/Typography';
import { useAuth0 } from 'utils/auth0';

const Users = API.Users();

const lightColor = 'rgba(255, 255, 255, 0.7)';

const styles = theme => ({
  actAsBar: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.primary.light,
  },
  iconButtonAvatar: {
    padding: 4,
  },
  link: {
    textDecoration: 'none',
    color: lightColor,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  button: {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.common.white,
    },
  },
  title: {
    flexGrow: 1,
  },
});

function HeaderActAs({ classes, meData }) {
  const { logout } = useAuth0();

  const blink = `@keyframes blink {
    0%		{ background-color: #10c018;}
		50%	  { background-color: #04a1d5;}
    100%  { background-color: #10c018;}
  }`;

  const revertToMe = async () => {
    const myId = meData.auth0RealUserId;
    await Users.actAsUser(myId, myId);
    logout();
  };

  return (
    <React.Fragment>
      <style>{blink} </style>
      <MuiAppBar
        className={classes.actAsBar}
        color="primary"
        position="sticky"
        elevation={6}
        style={{
          animationDuration: `1s`,
          animationIterationCount: 'infinite',
          animationName: `blink`,
        }}>
        <MuiToolbar>
          <MuiGrid container spacing={1} alignItems="center">
            <MuiTypography variant="h6" className={classes.title}>
              {`You Are Now Acting As ${meData?.name}. (${meData?.email})`}
            </MuiTypography>
            <MuiGrid item>
              <MuiButton
                onClick={revertToMe}
                className={classes.button}
                variant="outlined"
                color="inherit"
                size="small">
                Revert To Me
              </MuiButton>
            </MuiGrid>
          </MuiGrid>
        </MuiToolbar>
      </MuiAppBar>
    </React.Fragment>
  );
}

export default withStyles(styles)(withRouter(HeaderActAs));
